import { TableSortLabel } from '@mui/material'
import TableCell from '@mui/material/TableCell'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next'
import { SortableHeader } from 'tableTypes'
import IconComponent from './IconComponent'
import { getPixelInREM } from '../../../common/material'

export const useHeaderCellStyles = makeStyles((theme) => ({
    headerCell: {
        fontSize: getPixelInREM(16),
        color: theme.palette.grey[400],
        fontWeight: 400
    },
    sortIcon: {
        fontSize: 14,
        marginLeft: 5,
        marginTop: 5
    },
    sortActive: {
        fontWeight: 600,
        '&.MuiTableSortLabel-active': {
            color: theme.palette.grey[400]
        }
    }
}))

const HeaderCell = <SortingKeys,>({
    cell,
    sorting,
    handleSorting,
    translationNamespace,
    translationKey
}: SortableHeader<SortingKeys>) => {
    const { t } = useTranslation(translationNamespace)
    const styles = useHeaderCellStyles()
    const { id, sortable } = cell || {}
    const isSortingActive = sorting.property === (id as unknown as SortingKeys)
    const isAscending = sorting.direction === 'ASC'

    return sortable ? (
        <TableCell key={id} className={styles.headerCell}>
            <TableSortLabel
                active={isSortingActive}
                className={`${isSortingActive ? styles.sortActive : ''}`}
                direction={isAscending ? 'asc' : 'desc'}
                onClick={() => handleSorting(id)}
                IconComponent={IconComponent}
            >
                {t(`${translationKey}.${id}`)}
            </TableSortLabel>
        </TableCell>
    ) : (
        <TableCell key={id} className={styles.headerCell}>
            {t(`${translationKey}.${id}`)}
        </TableCell>
    )
}

export default HeaderCell
